module.exports = __webpack_public_path__ + "img/qilin-f-stage1-hungry.8ee23499.png";